/* eslint semi:0 */
import 'core-js'
import { renderReact } from 'hypernova-react'
import '../../jsCore/application/bootstrap_common'
import '../../components/body/uaBodyClassModifier'
import { initializeEllipsis } from '../../jsCore/utils/ellipsis'
import mountFanvoice from '../../components/fanvoice/fanvoiceContainer'
import mountHeaderComponents from '../../components/header/headerComponents'
import initSchedule from '../../components/schedule/scheduleHomepageContainer'
import localeCookieInitializer from '../../jsCore/organizedByType/initializers/localeCookieInitializer'
import initAnalytics from '../../jsCore/organizedByType/initializers/analyticsInitializer'
import trackAnalyticsClickEvents from '../../components/track_analytics_click_events/trackAnalyticsClickEvents'
import initAdblockDetectorProvider from '../../jsCore/providers/ads/adblockDetectorProvider'
import { LinksGroupContainer } from '../../../../../lib/provolution/components/links_group/presentation/views/linksGroup.container'
import initGoogleAds from '../../jsCore/organizedByType/initializers/ads/initGoogleAds'
import { initCommonComponents } from '../common/common'
import { initEiExternalScripts } from '../../jsCore/organizedByType/initializers/initEiExternalScripts'
import { initTheDuelExternalScripts } from '../../jsCore/organizedByType/initializers/initTheDuelExternalScripts'

initGoogleAds()
initAnalytics()
initCommonComponents()
initAdblockDetectorProvider()
localeCookieInitializer()
mountFanvoice()
mountHeaderComponents()
initializeEllipsis()
initSchedule()
trackAnalyticsClickEvents()
initEiExternalScripts()
initTheDuelExternalScripts()
renderReact('LinksGroupContainer', LinksGroupContainer)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/entry_points/homePage/homePage.js